import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-trash",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 7l16 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 11l0 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 11l0 6" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" })
	]
});
const ForwardRef = forwardRef(SvgTrash);
export default ForwardRef;
